var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFlagOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E7DD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24323_40289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24323_40289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 17.6663V22.6663C11.8334 22.9025 11.7536 23.1004 11.5938 23.2601C11.4341 23.4198 11.2362 23.4997 11.0001 23.4997C10.764 23.4997 10.5661 23.4198 10.4063 23.2601C10.2466 23.1004 10.1667 22.9025 10.1667 22.6663V10.1663C10.1667 9.93023 10.2466 9.73231 10.4063 9.57259C10.5661 9.41287 10.764 9.33301 11.0001 9.33301H16.9792C17.1737 9.33301 17.3473 9.39551 17.5001 9.52051C17.6529 9.64551 17.7501 9.80523 17.7917 9.99967L18.0001 10.9997H21.8334C22.0695 10.9997 22.2674 11.0795 22.4272 11.2393C22.5869 11.399 22.6667 11.5969 22.6667 11.833V18.4997C22.6667 18.7358 22.5869 18.9337 22.4272 19.0934C22.2674 19.2531 22.0695 19.333 21.8334 19.333H17.5209C17.3265 19.333 17.1529 19.2705 17.0001 19.1455C16.8473 19.0205 16.7501 18.8608 16.7084 18.6663L16.5001 17.6663H11.8334ZM18.2084 17.6663H21.0001V12.6663H17.3126C17.1181 12.6663 16.9445 12.6038 16.7917 12.4788C16.639 12.3538 16.5417 12.1941 16.5001 11.9997L16.2917 10.9997H11.8334V15.9997H17.1876C17.382 15.9997 17.5556 16.0622 17.7084 16.1872C17.8612 16.3122 17.9584 16.4719 18.0001 16.6663L18.2084 17.6663Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFlagOutline);
export default __webpack_public_path__ + "static/media/ai-flag-outline.b00e0fc4807be679ec304a72f97a06af.svg";
export { ForwardRef as ReactComponent };